import React from 'react'
import CallUs from '../components/Callus'
import ContactUs from '../components/emailsend'
import { Navbar } from '../components/navbar'
import styled from 'styled-components'
import { Footer } from '../components/footer'


const ContactStyle = styled(ContactUs)`

`;
const MotivationalText = styled.p`
line-height:2.0;
`

const ContactContainer = styled.div`
display:flex;
flex-direction:row;
padding:1rem;
align-items:center;

@media (max-width:780px){
    display:flex;
    flex-direction:column;
}
`;

function Contacts(){
    return(
        <div>
        <Navbar />
        <CallUs />  
        <h3 style={{textAlign:"center",color:"#000080"}}>Let's work for you</h3>

        <ContactContainer>
            <MotivationalText>
                Perhaps you need to get in touch with us,you want to request our assistance, or you have some
                clarifications on our designs or websites or even logo. Contact us.
            </MotivationalText>
            <ContactStyle/>
        </ContactContainer> 
        <Footer/>
        

        </div>
         )
}

export default Contacts